const ChangeHistoryIndex = () => import('@/modules/change-history/views/ChangeHistoryIndex.vue')
const ChangeHistoryShow = () => import('@/modules/change-history/views/ChangeHistoryShow.vue')

export default [
  {
    path: '/change-history',
    name: 'change-history.index',
    component: ChangeHistoryIndex,
    meta: { requiresAuthentication: true }
  },
  {
    path: '/change-history/:uuid',
    name: 'change-history.show',
    component: ChangeHistoryShow,
    meta: { requiresAuthentication: true }
  }
]
